<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field
          id="title"
          :label="$t('kyc.name_title')"
        >
          <div data-test="kyc-authorized-representative--title-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mr."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.mr') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Miss."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.miss') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mrs."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.mrs') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('title') }}</span>
      </div>
    </div>
    <div
      v-if="form.nationality === 'Thai'"
      class="columns"
    >
      <div class="column">
        <b-field
          id="first-name-thai"
          :label="$t('kyc.first_name_th')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.firstNameInThai"
            :placeholder="$t('kyc.first_name_th')"
            name="first name (Thai)"
            data-test="kyc-authorized-representative--first-name-thai-field"
            @blur="$emit('trackInputForm', { key: 'firstNameInThai', name: 'first name (Thai)', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name (Thai)') }}</span>
      </div>
      <div class="column">
        <b-field
          id="last-name-thai"
          :label="$t('kyc.last_name_th')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.lastNameInThai"
            :placeholder="$t('kyc.last_name_th')"
            name="last name (Thai)"
            data-test="kyc-authorized-representative--last-name-thai-field"
            @blur="$emit('trackInputForm', { key: 'lastNameInThai', name: 'last name (Thai)', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name (Thai)') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="first-name"
          :label="$t('kyc.first_name')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.firstName"
            :placeholder="$t('kyc.first_name')"
            name="first name"
            data-test="kyc-authorized-representative--first-name-field"
            @blur="$emit('trackInputForm', { key: 'firstName', name: 'first name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name') }}</span>
      </div>
      <div
        v-if="form.nationality !== 'Thai'"
        class="column"
      >
        <b-field
          id="middle-name"
          :label="$t('kyc.middle_name')"
        >
          <b-input
            v-model="form.middleName"
            :placeholder="$t('kyc.middle_name')"
            name="middle name"
            autocomplete="disabled"
            data-test="kyc-authorized-representative--middle-name-field"
            @blur="$emit('trackInputForm', { key: 'middleName', name: 'middle name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('middle name') }}</span>
      </div>
      <div class="column">
        <b-field
          id="last-name"
          :label="$t('kyc.last_name')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.lastName"
            :placeholder="$t('kyc.last_name')"
            name="last name"
            data-test="kyc-authorized-representative--last-name-field"
            @blur="$emit('trackInputForm', { key: 'lastName', name: 'last name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="gender"
          :label="$t('kyc.gender')"
        >
          <div data-test="kyc-authorized-representative--gender-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Male"
              name="gender"
              @click.native="$emit('trackInputForm', { key: 'gender', name: 'gender', page: 'Information' })"
            >
              {{ $t('kyc.male') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Female"
              name="gender"
              @click.native="$emit('trackInputForm', { key: 'gender', name: 'gender', page: 'Information' })"
            >
              {{ $t('kyc.female') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('gender') }}</span>
      </div>
      <div class="column">
        <b-field
          id="marital-status"
          :label="$t('kyc.marital_status')"
        >
          <div data-test="kyc-authorized-representative--marital-status-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Single"
              name="marital status"
              @click.native="$emit('trackInputForm', { key: 'maritalStatus', name: 'marital status', page: 'Information' })"
            >
              {{ $t('kyc.single') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Married"
              name="marital status"
              @click.native="$emit('trackInputForm', { key: 'maritalStatus', name: 'marital status', page: 'Information' })"
            >
              {{ $t('kyc.married') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('marital status') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="date-of-birth"
          :label="$t('kyc.date_of_birth')"
          data-test="kyc-authorized-representative--birthdate"
        >
          <b-datepicker
            v-validate="'required|ageMoreThanTwenty'"
            v-model="form.birthdate"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of birth"
            @input="$emit('trackInputForm', { key: 'birthdate', name: 'date of birth', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of birth') }}</span>
      </div>
      <div class="column">
        <b-field
          id="phone-number"
          :label="$t('kyc.tel_number')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.tel"
            :placeholder="$t('kyc.tel_placeholder')"
            name="phone number"
            data-test="kyc-authorized-representative--phone-number-field"
            @blur="$emit('trackInputForm', { key: 'tel', name: 'phone number', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('phone number') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="occupation"
          :label="$t('kyc.occupation')"
          class="kyc-information-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.career"
            :placeholder="$t('kyc.occupation')"
            name="occupation"
            data-test="kyc-authorized-representative--occupation-field"
            @blur="$emit('trackInputForm', { key: 'career', name: 'occupation', page: 'Information' })"
          >
            <option
              v-for="occupation in sortOccupationList"
              :value="occupation.key"
              :key="occupation.key"
              name="occupation"
            >
              {{ occupation[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('occupation') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { sortDataByLanguage } from '@/utils/helper'

export default {
  name: 'AuthorizedRepresentative',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    occupationList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sortOccupationList () {
      return sortDataByLanguage(this.occupationList, this.$i18n.locale)
    }
  },
  beforeDestroy () {
    this.$validator.pause()
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Organization/AuthorizedRepresentative.vue